import { Control, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

export interface FormTextAreaInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  rows?: number;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  onBlur?: () => void;
}

const FormTextAreaInput = ({
  control,
  name,
  placeholder,
  rows = 3,
  disabled = false,
  required = false,
  autoFocus = false,
  onBlur,
}: FormTextAreaInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={placeholder}
          variant="outlined"
          multiline
          rows={rows}
          fullWidth
          error={!!error}
          helperText={error?.message}
          autoFocus={autoFocus}
          disabled={disabled}
          required={required}
          onBlur={onBlur}
        />
      )}
    />
  );
};

export default FormTextAreaInput;